module.exports = __webpack_public_path__ + "static/media/checked-avatar.ed040e36.svg";